import React, { useEffect, useState } from 'react';
import APIHelper from 'src/helpers/api-helper';
import {Outlet, useNavigate} from "react-router";
import { useAppDispatch} from "src/redux/hooks";
import { setContext } from 'src/redux/context-slice';
import ApiError from "src/errors/api-error";
import i18n from 'i18next';
import StateInitializationHelper from "src/helpers/state-initialization-helper";
import {useStore} from "react-redux";
import CookieHelper from 'src/helpers/cookie-helper';
import CookieNames from 'src/constants/cookie-names';

// This react hook should be treated as the "root" for all components
export default function AppView() {
    const dispatch = useAppDispatch();
    const store = useStore();

    // On first initialization, we need to initialize the state based on query params
    useEffect(() => {
        StateInitializationHelper.initializeState(location, store);
    }, []);

    // Initialize our app state with the context data we'll need everywhere else
    useEffect(() => {
        APIHelper.getIdPUserContext().then(r => {
            dispatch(setContext(r));
            // When language cookie not present, set the locale to whatever the locale is set as in the response
            // here, since that should be the user's preferred language.
            if (!CookieHelper.getCookieValue(CookieNames.PREFERRED_LANGUAGE)) {
                i18n.changeLanguage(r.locale.replace('_', '-'));
            }
        }).catch((e : ApiError) => {
            // TODO: This represents a pretty serious error because there's a lot of data we need here, determine
            //  how best to respond here.
            console.error("Failed to fetch context.", e)
        });
    }, []);

    return (
        <Outlet />
    );
}
